import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import PageHero from "@/components/PageHero";
import { BRAND } from "@/config";

const CONTENT = {
  privacy: {
    eyebrow: "Legal",
    title: ["Privacy Policy"],
    sections: [
      { h: "Information we collect", p: "We collect information you provide through our enquiry, site-survey and newsletter forms — such as your name, company, phone number, email and message. We do not store this data in a database; submissions are delivered directly to our team by email." },
      { h: "How we use your information", p: "We use your information solely to respond to your enquiry, arrange site surveys, prepare quotes and, where you opt in, send occasional updates. We never sell your data." },
      { h: "Cookies", p: "We use minimal cookies to remember your cookie-consent preference and to understand site usage. You can control cookies through your browser settings." },
      { h: "Data security", p: "We apply reasonable technical and organisational measures to protect your information. Communications are handled through trusted, secure email infrastructure." },
      { h: "Your rights", p: "You may request access to, correction of, or deletion of the personal information you have shared with us at any time by contacting us." },
    ],
  },
  terms: {
    eyebrow: "Legal",
    title: ["Terms of Service"],
    sections: [
      { h: "Acceptance of terms", p: "By accessing and using this website, you accept and agree to be bound by these terms. If you do not agree, please discontinue use of the site." },
      { h: "Services", p: "KAS Info Tech provides security, surveillance and IT infrastructure solutions. Website content is for general information; specific engagements are governed by separate agreements." },
      { h: "Intellectual property", p: "All content, branding, text and images on this site are the property of KAS Info Tech unless otherwise stated, and may not be reproduced without permission." },
      { h: "Limitation of liability", p: "This website is provided on an 'as is' basis. KAS Info Tech is not liable for any indirect or consequential damages arising from use of the site." },
      { h: "Governing law", p: "These terms are governed by the laws of India, and any disputes are subject to the exclusive jurisdiction of the courts of Jaipur, Rajasthan." },
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const data = CONTENT[kind] || CONTENT.privacy;
  return (
    <div data-testid={`legal-page-${kind}`}>
      <PageHero eyebrow={data.eyebrow} titleLines={data.title} subtitle={`Last updated: January 2026 · ${BRAND.name}`} imageKey="server_room" />
      <section className="mx-auto max-w-3xl px-6 py-16 lg:px-10 lg:py-20">
        <div className="space-y-10">
          {data.sections.map((s) => (
            <div key={s.h}>
              <h2 className="flex items-center gap-2.5 font-display text-xl font-bold text-white"><ShieldCheck className="h-5 w-5 text-[#2563EB]" /> {s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-slate-400">{s.p}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 rounded-2xl border border-slate-800 bg-[#111c33]/40 p-8">
          <p className="text-slate-300">Questions about this policy? Reach us at <a href={`mailto:${BRAND.email}`} className="font-semibold text-[#60A5FA]">{BRAND.email}</a> or <Link to="/contact" className="font-semibold text-[#60A5FA]">contact us</Link>.</p>
        </div>
      </section>
    </div>
  );
}
